import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  getOnFleetErrorLogByShop,
  getSynchronizedTeamsByShop,
  synchronizeTeams,
} from '../../actions/integration'

import {
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
  ListItem,
  Divider,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

class OnFleetTeamInfoItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      onFleetTeamInfo: {},
      onFleetErrorLogs: [],
    }
  }

  componentDidMount() {
    const { shop = {} } = this.props
    this.props.dispatch(getOnFleetErrorLogByShop({ shopId: shop.id })).then((res) => {
      this.setState({
        onFleetErrorLogs: res.values || [],
      })
    })
    this.props.dispatch(getSynchronizedTeamsByShop({ shopId: shop.id })).then((res) => {
      this.setState({
        onFleetTeamInfo: res || {},
      })
    })
  }

  synchronizeTeam = () => {
    const { shop } = this.props
    this.props.dispatch(synchronizeTeams({ shopId: shop.id })).then((res) => {
      this.props.dispatch(getSynchronizedTeamsByShop({ shopId: shop.id })).then((res) => {
        Appcues.track('Synchronized Team')
        this.setState({
          onFleetTeamInfo: res || {},
        })
      })
    })
  }

  render() {
    const { shop = {}, index, selectedPanel } = this.props
    const { onFleetErrorLogs = [], onFleetTeamInfo = {} } = this.state
    const { onFleetTeamInfoList = [] } = onFleetTeamInfo

    return (
      <ExpansionPanel
        className="margin-top-small"
        expanded={selectedPanel === index}
        onChange={this.props.selectPanel(index)}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="title" gutterBottom className="tab-heading">
            {shop.name}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div className="full-width">
            {hasAccess() ? (
              <Button
                disabled={!shop.enableOnFleet}
                className="primary-button pull-right"
                onClick={this.synchronizeTeam}
              >
                Sync Teams
              </Button>
            ) : null}
            <Grid container className="listing-spacing">
              <ListItem>
                <Grid container>
                  <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>Synchronized Date:</Typography>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <Typography>
                      {moment(onFleetTeamInfo.syncDate).format('MMM DD, YYYY')}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} className="listing-spacing">
                {onFleetTeamInfoList && onFleetTeamInfoList.length ? (
                  <ListItem>
                    <Typography variant="headline" gutterBottom>
                      Onfleet Team
                    </Typography>
                  </ListItem>
                ) : null}
                {onFleetTeamInfoList &&
                  onFleetTeamInfoList.map((teamInfo, i) => {
                    return (
                      <Fragment key={i}>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                              Team Name
                            </Grid>
                            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                              {teamInfo.name}
                            </Grid>
                          </Grid>
                        </ListItem>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                              Team ID
                            </Grid>
                            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                              {teamInfo.teamId}
                            </Grid>
                          </Grid>
                        </ListItem>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                              Hub
                            </Grid>
                            <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                              {teamInfo.hub}
                            </Grid>
                          </Grid>
                        </ListItem>
                        <Divider />
                      </Fragment>
                    )
                  })}
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} className="margin-top-small">
                  <Typography variant="headline" gutterBottom>
                    Onfleet Error Log
                  </Typography>
                  <div className="error_log_table">
                    <div className="table-scroll">
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Timestamp</TableCell>
                            <TableCell>Error Type</TableCell>
                            <TableCell>Cause</TableCell>
                            <TableCell>BLAZE Message</TableCell>
                            <TableCell>Onfleet Error Message</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(onFleetErrorLogs &&
                            onFleetErrorLogs.length &&
                            onFleetErrorLogs.map((errorLog, i) => {
                              return (
                                <TableRow key={i}>
                                  <TableCell>
                                    {moment(errorLog.created).format('MM/DD/YYYY hh:mm A')}
                                  </TableCell>
                                  <TableCell>{errorLog.errorType}</TableCell>
                                  <TableCell>{errorLog.cause}</TableCell>
                                  <TableCell>
                                    {errorLog.message.replace('OnFleet', 'Onfleet')}
                                  </TableCell>
                                  <TableCell>
                                    {errorLog.onFleetMessage.replace('OnFleet', 'Onfleet')}
                                  </TableCell>
                                </TableRow>
                              )
                            })) || (
                            <TableRow>
                              <TableCell colSpan={12}>
                                <Typography className="text-center">
                                  No Error Logs for this shop.
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(OnFleetTeamInfoItem)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetTeamInfoItem.js